import i18next from 'i18next';
import cookie from 'cookie';
import { isLocalhost } from './urlUtils';
import { requestIsFromMobile } from './mobileUtils';

const SUPPORTED_LANGUAGES = ['en', 'fr'];

export function filterLanguage(language: string): string {
  if (language && SUPPORTED_LANGUAGES.includes(language)) {
    return language;
  }
  return null;
}

export function getLanguageFromLocale(locale: string): string {
  if (locale && locale.length >= 2) {
    return filterLanguage(locale.substring(0, 2));
  }
  return null;
}

export function getLanguageFromi18Next(): string {
  return getLanguageFromLocale(i18next.language);
}

export function getLanguageFromExtranetCookie(): string {
  const cookies = cookie.parse(document.cookie);
  if (!cookies.ee_language) return null;
  return getLanguageFromLocale(cookies.ee_language);
}

export function getLanguage(): string {
  let language = getLanguageFromi18Next();
  if (language !== null) return language;
  language = getLanguageFromExtranetCookie();
  if (language !== null) return language;
  return 'fr';
}

function setLanguageCookie(language: string) {
  document.cookie = cookie.serialize('ee_language', language, { path: '/' });
}

export function wedgeLanguageCookie() {
  const cookies = cookie.parse(document.cookie);
  const { location } = window;

  // For mobile, if language cookie is existing, use that as language to set the ee_language cookie, otherwise use the browser language
  if (requestIsFromMobile(new URLSearchParams(location.search)) || sessionStorage.getItem('mobileDeviceMode') === 'true') {
    const languageCookieValue = getLanguageFromLocale(cookies.language);
    const eeLanguageCookieValue = getLanguageFromLocale(cookies.ee_language);

    if (languageCookieValue && (!eeLanguageCookieValue || (languageCookieValue !== eeLanguageCookieValue))) {
      setLanguageCookie(languageCookieValue);
    }
    // if not mobile, if ee_language cookie is not existing, set it based on the domain
  } else if (!cookies.ee_language) {
    if (location.host === process.env.REACT_APP_DOMAIN_NAME_EN) {
      setLanguageCookie('en');
    }
    if (location.host === process.env.REACT_APP_DOMAIN_NAME_FR) {
      setLanguageCookie('fr');
    }
  }

  return isLocalhost();
}
